import React from "react";
import img from "../../images/carpeta.png"

const Icon = (props) => {
    function setShow(){
        props.show(props.id)
    }


    return(
        <div className="icon" onClick={setShow}>
            <div className="iconImg">
                <img src={img} alt="" />
            </div>
            <p>{props.name}</p>
        </div>
    )
}

export default Icon